import SelectTheme from './SelectTheme'
import ScrollActive from './ScrollActive'
import './HeaderLayout.css'
export default function HeaderLayout(){
    ScrollActive()
    const changeTheme = (event) =>{
        SelectTheme()
    }
    return (
        <header className="header" id="header">
            <nav className="nav container">
                <a href="/" className="nav__logo">Santi.Rev</a>

                <div className="nav__menu">
                    <ul className="nav__list">
                        <li className="nav__item">
                            <a href="/#home" className="nav__link active-link">
                                <i className='bx bx-home-alt'></i>
                                <span className="nav__name">Inicio</span>
                            </a>
                        </li>

                        <li className="nav__item">
                            <a href="/#about" className="nav__link">
                                <i className='bx bx-user' ></i>
                                <span className="nav__name">Sobre mí</span>
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="/#skills" className="nav__link">
                                <i className='bx bx-book' ></i>
                                <span className="nav__name">Skills</span>
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="/#experience" className="nav__link">
                                <i className='bx bx-briefcase-alt-2' ></i>
                                <span className="nav__name">Experiencia</span>
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="/#software" className="nav__link" aria-label="Software y productos">
                                <i className='bx bx-package'></i>
                                <span className="nav__name">Productos</span>
                            </a>
                        </li>
                        <li className="nav__item">
                            <a href="/#contact" className="nav__link">
                                <i className='bx bx-message-square-detail'></i>
                                <span className="nav__name">Contacto</span>
                            </a>
                        </li>
                    </ul>
                </div>
                {/* <!-- Theme change button --> */}
                <i className='bx bx-moon change-theme' id="theme-button" onClick={() => changeTheme()}></i>
            </nav>
        </header>
    )
}
